// src/api.js
import axios from "axios";
import { BASEURL } from "./utils";

const api = axios.create({
  baseURL: BASEURL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default api;
